import React, {useState} from 'react';
import {Button, Checkbox, Form, Icon, Modal} from 'semantic-ui-react';
import '../styles.scss';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import SelectedCard from '../commons/selectCardNotification';

const handleExportAvailable = (props) => {
  // Lógica para exportar los disponibles
  props.downloadTransitFile();
  console.log('Exportando disponibles2...');
};

const FormFilters = (props) => {
  const [openVehicleModal, setOpenVehicleModal] = useState(false);
  return (
    <>
      {props.group !== 'transit' ? (
        <>
          <div className="w-100 filters-inventory">
            <Form onSubmit={props.handleSubmit} className="w-100 export-lines-custom" >
              <Form.Field primary className="toyota-primary">
                <div className='flex'>
                  <Icon
                    name='bell'
                    color='red'
                    size='big'
                    className='bell'
                    onClick={() => setOpenVehicleModal(true)}
                  />
                  <div style={{
                    'marginTop': '2px',
                    'marginLeft': '-2px',
                    'fontSize': '16px',
                    'fontWeight': 'bold',
                  }}>{props.notificationCount}</div>
                  <Modal open = {openVehicleModal}>
                    <Modal.Header>
                    Vehículos priorizados con menor días de antiguedad
                    </Modal.Header>
                    <Modal.Content>
                      <div className='priorization-container-mini-cards'
                        style={{
                          'overflowY': 'scroll',
                          'maxHeight': '400px', // Limita la altura del contenedor
                          'border': '1px solid #ddd',
                          'padding': '10px',
                          'borderRadius': '5px',
                          'backgroundColor': '#fff',
                        }}
                      >
                        {<SelectedCard
                          data={props.notification}
                          fetchUpdateNotification={props.fetchUpdateNotification}
                        />}
                      </div>
                    </Modal.Content>
                    <Modal.Actions>
                      <Button onClick={() => setOpenVehicleModal(false)}>
                      Cancelar
                      </Button>
                    </Modal.Actions>
                  </Modal>
                </div>
              </Form.Field>
              <Form.Field>
                <Checkbox
                  label="Menos de 30 días"
                  name="checkboxRadioGroup"
                  checked={props.filters.lessThan}
                  className="checkbox-export-inventory"
                  onChange={(e, data) =>
                    props.generatefilteredRows(
                      'lessThan',
                      !props.filters.lessThan
                    )
                  }
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  label="Entre 30 y 60 días"
                  name="checkboxRadioGroup"
                  checked={props.filters.between}
                  className="checkbox-export-inventory"
                  onChange={(e, data) =>
                    props.generatefilteredRows(
                      'between',
                      !props.filters.between
                    )
                  }
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  label="Más de 60 días"
                  name="checkboxRadioGroup"
                  checked={props.filters.greaterThan}
                  className="checkbox-export-inventory"
                  onChange={(e, data) =>
                    props.generatefilteredRows(
                      'greaterThan',
                      !props.filters.greaterThan
                    )
                  }
                />
              </Form.Field>
              <Form.Field>
                <Checkbox
                  label="Todo"
                  name="checkboxRadioGroup"
                  checked={props.filters.all}
                  className="checkbox-export-inventory"
                  onChange={(e, data) =>
                    props.generatefilteredRows('all', !props.filters.all)
                  }
                />
              </Form.Field>
              <Form.Field control={Button} primary className="toyota-primary margin:0">
                EXPORTAR
              </Form.Field>
            </Form>
          </div>
        </>
      ) : (
        <>
          <Form
            onSubmit={props.handleSubmit}
            className="export-lines-custom-transit"
          >
            <div style={{'display': 'flex', 'gap': '10px'}}>
              <Form.Field control={Button} primary className="toyota-primary">
                EXPORTAR
              </Form.Field>
              <Form.Field control={Button} secondary className="toyota-secondary margin:0"
                onClick={() => handleExportAvailable(props)}>
                EXPORTAR DISPONIBLES
              </Form.Field>
            </div>
          </Form>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'modelsByLine': state.vehiclesInventory.modelsByLine,
    'excelData': state.vehiclesInventory.excelData,
    'notificationCount': state.vehiclesInventory.notificationCount,
    'notification': state.vehiclesInventory.notification,
    'url': state.vehiclesInventory.url,
  };
};

const {
  fetchDealers,
  fetchModelsLinesByFilters,
  fetchVehicleTypeCatalog,
  setFilterInventory,
  updateTable,
  fetchUpdateNotification,
  downloadTransitFile,
} = Actions;

export default connect(mapStateToProps, {
  fetchDealers,
  fetchModelsLinesByFilters,
  fetchVehicleTypeCatalog,
  setFilterInventory,
  updateTable,
  fetchUpdateNotification,
  downloadTransitFile,
})(FormFilters);
